import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=5ba433ca"
import script from "./Emoji.vue?vue&type=script&lang=js"
export * from "./Emoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports